import request from "../utils/request";

const activity = '/activity'

//获取主活动id和时间
export function activityMsg (data) {
    return request({
        method: 'get',
        url: activity + '/v3/public/rank-page',
        data
    })
}

//获取主活动信息
export function mainActivity (rankId) {
    return request({
        method: 'get',
        url: activity + `/v3/public/rank-sub/${rankId}`
    })
}

//获取子活动信息
export function subActivity (data) {
    return request({
        method: 'get',
        url: activity + '/v3/public/rank-standing',
        data
    })
}

//报名
export function application (rankId) {
    return request({
        method: 'post',
        url: activity + `/v3/rank-apply/${rankId}`,
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
    })
}

//主活动规则 最底部的
export function mainRuler (rankId) {
    return request({
        method: 'get',
        url: activity + `/v3/public/rank/rules/${rankId}`,
    })
}

//子活动规则  奖励规则
export function subRuler (rankSubId) {
    return request({
        method: 'get',
        url: activity + `/v3/public/rank-sub/rules/${rankSubId}`,
    })
}

//查看是否已报名
export function whetherApplication (rankId) {
    return request({
        method: 'get',
        url: activity + `/v3/${rankId}/rank-apply`,
    })
}


// WEBPACK FOOTER //
// ./src/api/ChristmasActivities.js